




























import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import Alert from '@/components/atoms/Alert.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import ListItem from '@/components/molecules/ListItem.vue'
import ConfettiModal from '@/components/organisms/ConfettiModal.vue'
import { State as benefitsState } from '@/store/modules/benefits'

export default Vue.extend({
  name: 'ItemUse',
  components: {
    SimpleLoader,
    PageTitle,
    Alert,
    ButtonWrap,
    RoundButton,
    ListItem,
    ConfettiModal
  },
  data() {
    return {
      email: '',
      message: '氏名：\n生年月日：\n郵便番号：\n住所：\n電話番号：'
    }
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.tickets.isTicketsLoading
    },
    isUsedComplete(): boolean {
      return this.$state.tickets.isUsedComplete
    },
    validationCount(): string {
      return this.message.length > 280 ? 'is-error' : ''
    },
    benefit(): benefitsState['benefitDetil'] | null {
      return this.$state.benefits.benefitDetil
    },
    author(): string {
      const id = this.benefit ? this.benefit.id : ''
      const arr = this.$state.tickets.tickets ? this.$state.tickets.tickets.tickets.filter((ticket: any) => ticket.benefit === id) : []
      return arr.length > 0 ? arr[0].holder_name : ''
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('tickets/postTicketsUse', {
        ticket_id: this.$state.tickets.ticketId,
        email: this.email,
        message: this.message
      })
    },
    transitionHome() {
      this.$router.push('/home')
    }
  },
  mounted() {
    if (this.$state.tickets.ticketId.length === 0) {
      this.$router.push('/items')
    }
  }
})
